import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import MigrationFeaturesContainer from './container/MigrationFeaturesContainer';
import MigrationFeaturesHeader from './header/MigrationFeaturesHeader';
import MigrationFeatureGrid from './grid/MigrationFeatureGrid';

const MigrationFeatures = () => {
  const { t } = useTranslatedContent('migration');

  return (
    <MigrationFeaturesContainer>
      <MigrationFeaturesHeader 
        title={t('features.title')}
        subtitle={t('features.subtitle')}
      />
      <MigrationFeatureGrid 
        features={t('features.items', { returnObjects: true })}
      />
    </MigrationFeaturesContainer>
  );
};

export default MigrationFeatures;